"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapPropsToValues = void 0;
const mapFontWeight_1 = require("./mapFontWeight");
const mapSpacingToPixel_1 = require("./mapSpacingToPixel");
const PaddingConst = [
    "padding",
    "padding-left",
    "padding-right",
    "padding-bottom",
    "padding-top",
];
const MarginConst = [
    "margin",
    "margin-left",
    "margin-right",
    "margin-bottom",
    "margin-top",
];
const DirectionConst = ["top", "right", "bottom", "left"];
const mapPropsToValues = ({ value, property, }) => {
    if ([...PaddingConst, ...DirectionConst, ...MarginConst, "gap"].includes(property)) {
        return (0, mapSpacingToPixel_1.mapSpacingToPixels)(value);
    }
    else if (property === "font-weight") {
        return (0, mapFontWeight_1.mapFontWeight)(value);
    }
    else {
        return value;
    }
};
exports.mapPropsToValues = mapPropsToValues;
//# sourceMappingURL=mapPropsToValues.js.map